import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchFollowUpRequest = async (variables: { phoneNumber: string }) => {
  const response = await queryExecute({
    variables,
    fetchPolicy: 'no-cache',
    query: graphql(`
      query FollowUpRequest($phoneNumber: String!) {
        followUpRequest(phoneNumber: $phoneNumber) {
          id
          phoneNumber
          followUpAt
          serviceType
          callLogId
          callerId
          notes
          followUpCallLogId
        }
      }
    `),
  });
  return response.data?.followUpRequest ?? null;
};
